import { defineMessages } from 'react-intl';

export default defineMessages({
    failedToFetchComission: {
        id: 'ent.agent.commissionStatements.failed to fetch Commission Statements',
        defaultMessage: 'Failed to fetch the Commission Statements. Please try again later'
    },
    unableToDownloadStatement: {
        id: 'ent.agent.commissionStatements.Unable to download Commission Statements',
        defaultMessage: 'Unable to download Commission Statements.'
    },

})